<template>
    <div>
        <topnav :toptype="toptype"></topnav>
        <div class="" style="min-height: 600px">
            <div class="">
                <!-- <el-image class="topimg" src="/static/assets/images/p5.png" fit="fill"></el-image> -->
                <el-image
                    class="topimg"
                    :src="timg | addurl"
                    fit="fill"
                ></el-image>
            </div>
            <div class="response bggray" style="padding: 30px 0">
                <div class="marginauto comswidth">
                    <div class="marginauto" style="width: 50%">
                        <div
                            class="text-center"
                            style="
                                color: #1b1b1b;
                                font-size: 28px;
                                margin-bottom: 70px;
                                font-weight: 600;
                            "
                        >
                            请填写入驻信息
                        </div>
                        <el-form
                            :model="ruleForm"
                            :rules="rules"
                            ref="ruleForm"
                            label-width="200px"
                            class="demo-ruleForm"
                        >
                            <el-form-item label="企业名称" prop="shop_name">
                                <el-input
                                    placeholder="请输入企业名称"
                                    v-model="ruleForm.shop_name"
                                ></el-input>
                            </el-form-item>
                            <el-form-item label="联系人" prop="people_name">
                                <el-input
                                    placeholder="请输入联系人"
                                    v-model="ruleForm.people_name"
                                ></el-input>
                            </el-form-item>
                            <el-form-item label="联系方式" prop="mobile">
                                <el-input
                                    placeholder="请输入联系方式"
                                    v-model="ruleForm.mobile"
                                ></el-input>
                            </el-form-item>
                            <el-form-item label="入驻地址" prop="site_id">
								
								
								
                                <el-cascader
                                    placeholder="请选择注册地址"
                                    style="width: 100%"
                                    v-model="ruleForm.site_id"
                                    :options="addresslist"
                                    :props="{
                                        expandTrigger: 'hover',
                                        value: 'id',
                                        label: 'name',
                                        children: 'children',
                                    }"
                                    @change="chooseArea"
                                ></el-cascader>
                            </el-form-item>
                            <!-- <el-form-item label="详细地址" prop="address">
                                <el-input placeholder="请输入详细地址" v-model="ruleForm.address"></el-input>
                            </el-form-item>
                            <div class="dbtn">
                                <el-form-item label="企业类型" prop="cat_id">
                                    <el-select multiple v-model="ruleForm.cat_id" clearable placeholder="请选择企业类型">
                                        <el-option
                                            v-for="(item,index) in sortlist"
                                            :key="index"
                                            :label="item.name"
                                            :value="item.id" 
                                            style="width: 460px;" 
                                            >
                                        </el-option>
                                    </el-select>
                                </el-form-item>
                            </div>
                            <el-form-item label="营业执照" prop="license">
                                <el-upload
                                    class="avatar-uploader"
                                    action="https://ms.daoben.tech/api/common/upload"
                                    accept="image/*"
                                    :show-file-list="false"
                                    :on-success="Successone"
                                    :on-error="uploaderror"
                                    name="file"
                                    :data="uploaddata1"
                                    >
                                    <img v-if="ruleForm.license" :src="ruleForm.license | addurl" class="avatar">
                                    <i v-else class="el-icon-plus avatar-uploader-icon"></i>
                                </el-upload>
                            </el-form-item>
                            <el-form-item label="法人身份证（身份证正面）" prop="befor_pic">
                                <el-upload
                                    class="avatar-uploader"
                                    :action="action"
                                    :show-file-list="false"
                                    :on-success="Successone"
                                    :data="uploaddata2"
                                    >
                                    <img v-if="ruleForm.befor_pic" :src="ruleForm.befor_pic | addurl" class="avatar">
                                    <i v-else class="el-icon-plus avatar-uploader-icon"></i>
                                </el-upload>
                            </el-form-item>
                            <el-form-item label="法人身份证（身份证反面）" prop="after_pic">
                                <el-upload
                                    class="avatar-uploader"
                                    :action="action"
                                    :show-file-list="false"
                                    :on-success="Successone"
                                    :data="uploaddata3"
                                    >
                                    <img v-if="ruleForm.after_pic" :src="ruleForm.after_pic | addurl" class="avatar">
                                    <i v-else class="el-icon-plus avatar-uploader-icon"></i>
                                </el-upload>
                            </el-form-item>
                            <el-form-item label="企业LOGO" prop="shop_logo">
                                <el-upload
                                    class="avatar-uploader"
                                    :action="action"
                                    :show-file-list="false"
                                    :on-success="Successone"
                                    :data="uploaddata4"
                                    >
                                    <img v-if="ruleForm.shop_logo" :src="ruleForm.shop_logo | addurl" class="avatar">
                                    <i v-else class="el-icon-plus avatar-uploader-icon"></i>
                                </el-upload>
                            </el-form-item> -->
                            <el-form-item>
                                <el-button
                                    type="primary"
                                    @click="submitForm('ruleForm')"
                                    >提交申请</el-button
                                >
                                <!-- <el-button @click="resetForm('ruleForm')">重置</el-button> -->
                            </el-form-item>
                        </el-form>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>
<script>
import { regionData, CodeToText } from "element-china-area-data";
import { mapGetters } from "vuex";
export default {
    computed: {
        ...mapGetters(["userinfo", "type", "token"]),
    },
    data() {
        return {
            timg: "p5.png",
            toptype: 8,
            options: regionData,
            ruleForm: {
                user_id: "",
                shop_name: "",
                people_name: "",
                mobile: "",
				site_id:'',
                address: "",
                cat_id: [],
                license: "",
                befor_pic: "",
                after_pic: "",
                shop_logo: "",
                province: "",
                city: "",
                district: "",
            },
            action: "https://yt.daoben.net/api/common/upload",
            sortlist: [],
            rules: {
                shop_name: [
                    {
                        required: true,
                        message: "请输入企业名称",
                        trigger: "blur",
                    },
                ],
                people_name: [
                    {
                        required: true,
                        message: "请输入联系人",
                        trigger: "blur",
                    },
                ],
                mobile: [
                    {
                        required: true,
                        message: "请输入联系方式",
                        trigger: "blur",
                    },
                    {
                        min: 11,
                        max: 11,
                        message: "请输入正确的手机号",
                        trigger: "blur",
                    },
                ],
                site_id: [
                    { required: true, message: "请选择地址", trigger: "blur" },
                ],
                // address: [
                //     { required: true, message: '请输入详细地址', trigger: 'blur' },
                // ],
                // cat_id: [
                //     { required: true, message: '请选择分类', trigger: 'blur' },
                // ],
                // license: [
                //     { required: true, message: '请上传营业执照', trigger: 'blur' },
                // ],
                // befor_pic: [
                //     { required: true, message: '请上传身份证正面', trigger: 'blur' },
                // ],
                // after_pic: [
                //     { required: true, message: '请上传身份证反面', trigger: 'blur' },
                // ],
                // shop_logo: [
                //     { required: true, message: '请上传企业LOGO', trigger: 'blur' },
                // ]
            },
            addresslist: [],
            uploaddata1: {
                name: "license",
            },
            uploaddata2: {
                name: "befor_pic",
            },
            uploaddata3: {
                name: "after_pic",
            },
            uploaddata4: {
                name: "shop_logo",
            },
            id: 0,
        };
    },
    methods: {
        getsortlist() {
            this.$api.index.shop_category().then((response) => {
                this.sortlist = response.data;
            });
        },
        getaddress() {
            var data = {
                parent_id: -1,
            };
            // this.$api.index.getRegionList(data).then((response) => {
            //     this.addresslist = response.data;
            //     // console.log('this.addresslist',this.addresslist)
            // });
            this.$api.index.rz_list(data).then((response) => {
                console.log("地址：",response);
                this.addresslist = response.data;
                // console.log('this.addresslist',this.addresslist)
            });            
        },
        Successone(res, file) {
            console.log("res", res, file);
            this.ruleForm[res.data.name] = res.data.url;
        },
        handleAvatarSuccess(res, file) {
            console.log("res", res, file);
            this.ruleForm.imageUrl = URL.createObjectURL(file.raw);
        },
        uploaderror(e) {
            console.log(e);
        },
        beforeAvatarUpload(file) {
            const isJPG = file.type === "image/jpeg";
            const isLt5M = file.size / 1024 / 1024 < 5;

            // if (!isJPG) {
            // this.$message.error('上传头像图片只能是 JPG 格式!');
            // }
            if (!isLt5M) {
                this.$message.error("上传头像图片大小不能超过 5MB!");
            }
            return isJPG && isLt5M;
        },
        chooseArea(value) {
            //区域地址改变
			// console.log(value[0],55)
			this.ruleForm.site_id = value[0]
            // console.log('chooseArea ==> ', value)//展示的你选择的值 是一个areaCode
            // console.log(CodeToText[value[0]], CodeToText[value[1]], CodeToText[value[2]]); ///areaCode 对应的省市区 建议添加的时候 一定要保存 areaCode 用于编辑的时候
            // this.ruleForm.province = value[0];
            // this.ruleForm.city = value[1];
            // this.ruleForm.district = value[2];
        },
        handleSizeChange() {},
        handleCurrentChange(currentPage) {
            this.currentPage = currentPage;
        },
        submitForm(formName) {
            console.log(this.ruleForm);
            this.$refs[formName].validate((valid) => {
                if (valid) {
                    // alert('submit!');
                    this.tosub();
                } else {
                    console.log("error submit!!");
                    return false;
                }
            });
        },
        resetForm(formName) {
            this.$refs[formName].resetFields();
        },
        tosub() {
            this.ruleForm.user_id = this.token;
            console.log("this.ruleForm.cat_id", this.ruleForm.cat_id);
            // return false;
            if (this.id) {
                this.ruleForm["id"] = this.id;
            }
            // this.ruleForm.cat_id = this.ruleForm.cat_id.join(",");
            var data = this.ruleForm;

            this.$api.index.shop_submit(data).then((res) => {
                console.log(res);
                this.$message.success(res.msg);
                this.$store.dispatch("user/userinfo", this.token);
                setTimeout(() => {
                    this.ruleForm = {
                        user_id: "",
                        shop_name: "",
                        people_name: "",
                        mobile: "",
                        areaArr: [],
                        address: "",
                        cat_id: [],
                        license: "",
                        befor_pic: "",
                        after_pic: "",
                        shop_logo: "",
                        province: "",
                        city: "",
                        district: "",
                    };
                    this.$router.push({ path: "/company" });
                }, 800);
            });
        },
    },
    created() {
        this.id = this.$route.query.id ? this.$route.query.id : 0;
        this.getaddress();
        this.getsortlist();
    },
};
</script>
<style>
.dbtn .el-select .el-input {
    width: 460px;
}
.avatar-uploader .el-upload {
    border: 1px dashed #d9d9d9;
    border-radius: 6px;
    cursor: pointer;
    position: relative;
    overflow: hidden;
}
.avatar-uploader .el-upload:hover {
    border-color: #409eff;
}
.avatar-uploader-icon {
    font-size: 28px;
    color: #8c939d;
    width: 178px;
    height: 178px;
    line-height: 178px !important;
    text-align: center;
}
.avatar {
    width: 178px;
    height: 178px;
    display: block;
}
</style>
<style scoped>
.comswidth {
    width: 1320px;
    background-color: #fff;
    border-radius: 10px;
    padding: 70px 0;
}
.topimg {
    width: 100%;
    height: 500px;
    display: block;
}
.bggray {
    background-color: #eef1fa;
}
</style>


// WEBPACK FOOTER //
// companyinfo.vue?40cbaf7a